// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__VUEJQ","loaderDot":"Loader_loaderDot__ZrsKy"};